import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=c6a70ee2&scoped=true&lang=html&"
import script from "./Templates.vue?vue&type=script&lang=js&"
export * from "./Templates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a70ee2",
  null
  
)

export default component.exports